import { render, staticRenderFns } from "./InspectieStap.vue?vue&type=template&id=62bc0ae1"
import script from "./InspectieStap.vue?vue&type=script&lang=js"
export * from "./InspectieStap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports